import debugFactory from "debug";
export * from "./piggyBack";
export * from "./getPagedRequest";
export * from "./ioModule";
export * from "./axiosWithParallelLimit";
export * from "./channelHelpers";
export * from "./domain";
export { default as RetryRequest } from "./RetryRequest";

export function requestHeaderNormalizerInterceptor( config ) {
	const originalHeaders = config.headers || {};
	const _headers = {};
	Object.keys( originalHeaders ).forEach( h => {
		_headers[ h.toLowerCase() ] = originalHeaders[ h ];
	} );

	if ( !_headers[ "content-type" ] ) {
		_headers[ "content-type" ] = "application/json";
	}

	config.headers = _headers;
	return config;
}

export function authInterceptorFactory( { authService, } ) {
	return async function authInterceptor( config ) {
		if ( !config.headers?.authorization && !config.skipAuth ) {
			let token = await authService.getIdToken();
			if ( !token ) {
				await authService.renewTokens();
				token = await authService.getIdToken();
			}
			if ( token ) {
				config.headers.authorization = `Bearer ${ token }`;
			}
		}
		return Promise.resolve( config );
	};
}

export function normalizeResponseData( axiosResponse, axiosRequest, error = null ) {
	const debug = debugFactory( "teaming:common-io:axios:normalizeResponseData" );

	debug( { axiosResponse, axiosRequest, error, } );

	const normalizedResponse = {
		...( error || axiosResponse || {} ),
		status: axiosResponse?.status || axiosRequest?.status || 0,
		headers: axiosResponse?.headers || {},
		error,
		metaData: {
			isSuccessful: !error,
			// TODO: add appropriate header metadata
			version: axiosResponse?.headers?.version || 0,
		},
	};

	debug( { normalizedResponse, } );

	return normalizedResponse;
}

/**
 * @code
 * axios.interceptors.response.use( ...interceptAndNormalizeResponse() );
 */
export function interceptAndNormalizeResponse() {
	/**
	 * Occurs when status is within 200 range
	 * @see https://axios-http.com/docs/res_schema
	 * @param axiosResponse
	 * @param {Object} axiosResponse.data
	 * @param {Object} axiosResponse.config
	 * @param {Object} axiosResponse.headers
	 * @param {Object} axiosResponse.request
	 * @param {String} axiosResponse.statusText
	 * @param {Number} axiosResponse.status - status code
	 */
	const normalizeSuccess = axiosResponse => {
		const debug = debugFactory( "teaming:common-io:axios:normalizeSuccess" );

		const normalizedResponse = normalizeResponseData( axiosResponse, axiosResponse.request );

		debug( {
			axiosResponse,
			normalizedResponse,
		} );

		return Promise.resolve( normalizedResponse );
	};

	/**
	 * Occurs when status is NOT within 200 range
	 * @see https://axios-http.com/docs/handling_errors
	 * @param {Error} axiosError
	 */
	const normalizeError = axiosError => {
		const debug = debugFactory( "teaming:common-io:axios:normalizeError" );

		while ( axiosError.error ) {
			axiosError = axiosError.error;
		}

		const normalizedResponse = normalizeResponseData( axiosError.response, axiosError.request, axiosError );

		debug( {
			axiosError,
			normalizedResponse,
		} );

		return Promise.reject( normalizedResponse );
	};

	return [ normalizeSuccess, normalizeError, ];
}
